(function () {
    'use strict';

    angular.module("imApp").factory("domObjectService", ['$ihttp', function ($ihttp) {
        let service = {
            getDomObject: function (parms) {
                return $ihttp.post({
                    method: 3032,
                    parameters: parms || {}
                });
            },
            listDomObjectTypes: function (parms) {
                return $ihttp.post({
                    method: 3033,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
